import React from "react";
import PortraitProgramLayout from "./PortraitProgramLayout";
import { useAuthContext } from "../../context/auth";
import {
  getExerciseMinutes,
  getMinute,
  getTimeToKo,
} from "../../utils/getMinute";

function MainExerInfo() {
  const { basicProgram } = useAuthContext();
  if (!basicProgram) {
    return null;
  }
  return (
    <PortraitProgramLayout>
      <div className="w-full h-full flex justify-center items-center">
        <div className="flex flex-col gap-[120px] items-center">
          <h1 className="gradient-text text-[60px] font-extrabold">
            MAIN EXER
          </h1>
          <div className="flex flex-col gap-[60px] items-center">
            <div className="flex flex-col gap-[10px] items-center">
              <h3 className="text-[60px] font-bold text-white leading-[90px]">
                동작 개수
              </h3>
              <h1 className="text-[120px] leading-[140px] font-extrabold gradient-text">
                {basicProgram.mainExers.length} 동작
              </h1>
            </div>
            <div className="w-[220px] h-[6px] bg-[#FFA9C0]" />
            <div className="flex flex-col gap-[10px] items-center">
              <h3 className="text-[60px] font-bold text-white leading-[90px]">
                총 시간
              </h3>
              <h1 className="text-[120px] leading-[140px] font-extrabold gradient-text">
                {getTimeToKo(getExerciseMinutes(basicProgram))}
              </h1>
            </div>
            <div className="w-[220px] h-[6px] bg-[#FFA9C0]" />
            {/* <div className="flex flex-col gap-[10px] items-center">
              <h3 className="text-[60px] font-bold text-white leading-[90px]">
                반복 횟수
              </h3>
              <h1 className="text-[120px] leading-[140px] font-extrabold gradient-text">
                {3} 회
              </h1>
            </div> */}
          </div>
        </div>
      </div>
    </PortraitProgramLayout>
  );
}

export default MainExerInfo;
